export { default as Legend } from 'components/Charting/Legend/Legend';
